import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useI18n } from "../../i18n";

export const SeoManager = () => {
  const { t, lang } = useI18n();
  const { pathname } = useLocation();

  useEffect(() => {
    const impact = pathname.startsWith("/impact-social");
    document.title = impact ? t("impact.seoTitle") : t("seo.title");
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", impact ? t("impact.seoDesc") : t("seo.description"));
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", impact ? "https://consultantsucces.ca/impact-social" : "https://consultantsucces.ca/");
  }, [pathname, lang, t]);

  return null;
};

export default SeoManager;
